import type { LocaleMessageBundle } from '../../types'

export const tableMessages: LocaleMessageBundle = {
  vi: {
    'table.columns.closeSettings': 'Đóng thiết lập cột',
    'table.columns.dialogLabel': 'Cột hiển thị',
    'table.columns.title': 'Cột hiển thị',
    'table.columns.description': 'Chọn các cột muốn hiển thị trong bảng',
    'table.actions.close': 'Đóng',
    'table.loading': 'Đang tải dữ liệu...',
    'table.empty': 'Không có dữ liệu',
    'table.filters.search': 'Tìm kiếm',
    'table.filters.clear': 'Xóa lọc',
    'table.filters.filter': 'Bộ lọc',
    'table.filters.advanced': 'Bộ lọc nâng cao',
    'table.filters.apply': 'Áp dụng',
    'table.filters.reset': 'Đặt lại',
    'table.filters.activeCount': '{count} đang chọn',
    'table.filters.from': '{field} từ',
    'table.filters.to': '{field} đến',
    'table.pagination.itemsPerPage': 'Hiển thị',
    'table.pagination.currentPage': 'Trang {page} / {total}',
    'table.pagination.itemsPerPageSuffix': 'kết quả mỗi trang',
    'table.pagination.range': '{start} - {end} của {total} kết quả',
  },
  en: {
    'table.columns.closeSettings': 'Close column settings',
    'table.columns.dialogLabel': 'Visible columns',
    'table.columns.title': 'Visible columns',
    'table.columns.description': 'Choose the columns to show in the table',
    'table.actions.close': 'Close',
    'table.loading': 'Loading data...',
    'table.empty': 'No data',
    'table.filters.search': 'Search',
    'table.filters.clear': 'Clear filters',
    'table.filters.filter': 'Filter',
    'table.filters.advanced': 'Advanced Filters',
    'table.filters.apply': 'Apply',
    'table.filters.reset': 'Reset',
    'table.filters.activeCount': '{count} active',
    'table.filters.from': '{field} from',
    'table.filters.to': '{field} to',
    'table.pagination.itemsPerPage': 'Show',
    'table.pagination.currentPage': 'Page {page} / {total}',
    'table.pagination.itemsPerPageSuffix': 'results per page',
    'table.pagination.range': '{start} - {end} of {total} results',
  },
}
